import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/mui";
import { Stack, Typography, Alert } from "@mui/material";

import { DetailSection, FieldGrid, FieldItem } from "components/detail";

export const BookmarkShow = () => {
    const { queryResult } = useShow();
    const { data, isLoading, isError } = queryResult;
    const record = data?.data;

    return (
        <Show
            isLoading={isLoading}
            title={
                <Typography variant="h5">
                    이야기 북마크 상세{record?.id ? ` · ${record.id}` : ""}
                </Typography>
            }
        >
            {isError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    이야기 북마크 정보를 불러오지 못했습니다.
                </Alert>
            )}

            <Stack spacing={2}>
                <DetailSection title="기본 정보">
                    <FieldGrid columns={2}>
                        {/* bookmarkColumns.tsx와 동일한 필드/라벨(issue #69: 기존 dtype/message는 실존하지 않는 필드였음) */}
                        <FieldItem label="사용자ID" value={record?.userId} />
                        <FieldItem label="이야기게시판ID" value={record?.boardId} />
                        <FieldItem label="생성일" value={record?.createdDate} />
                        <FieldItem label="수정일" value={record?.updatedDate} />
                    </FieldGrid>
                </DetailSection>
            </Stack>
        </Show>
    );
};
